import { TIMER_SAVE_HISTORY_KEY } from '../core/storage.js';

export { TIMER_SAVE_HISTORY_KEY };

function preferenceStorage(storage) {
  return storage ?? window.localStorage;
}

export function loadTimerSaveHistoryPreference(storage) {
  try {
    const value = preferenceStorage(storage).getItem(TIMER_SAVE_HISTORY_KEY);
    if (value === 'false') return false;
    if (value === 'true') return true;
  } catch {
    return true;
  }
  return true;
}

export function saveTimerSaveHistoryPreference(enabled, storage) {
  const normalized = Boolean(enabled);
  preferenceStorage(storage).setItem(TIMER_SAVE_HISTORY_KEY, String(normalized));
  return normalized;
}
